import styled from '@emotion/styled'
import {Card, Flex, Typography} from "antd";
import {useTranslation} from "react-i18next";

const ErrorWrapper = styled(Card)`
  border: 1px solid #ff4d4f;
`

const Content = styled(Flex)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const userEmailNotFoundTranslation = {
    "en": {
        "title": "You member id does not have an email",
        "contact": "If you want to use login with email, please ",
        "contact-link": "contact with us"
    },
    "fi": {
        "title": "Jäsennumerolla ei ole sähköpostia",
        "contact": "Jos haluat kirjautua sähköpostilla, ole hyvä ja ",
        "contact-link": "ota yhteyttä meihin"
    }
}

export const UserEmailNotFoundError = () => {
    const {t} = useTranslation(['emailNotFound']);
    return (
        <ErrorWrapper size={'small'}>
            <Content>
                <Typography.Text type="danger">{t(`title`)}</Typography.Text>
                <Typography.Text>{t('contact')}<a target={"__blank"}
                                                  href={'https://www.suomengolfseniorit.fi/yhteystiedot'}> {t('contact-link')}</a></Typography.Text>


            </Content>

        </ErrorWrapper>
    )
}
